<template>
  <q-card
    class="cursor-pointer"
    :class="{
      'col q-mx-auto': $isLandscapeView() && $q.screen.gt.xs && !compact,
      'q-mx-sm': $q.screen.xs
    }"
    :style="{
      'max-width': $isLandscapeView() && $q.screen.gt.xs && !compact ? '350px' : '800px',
      'margin-bottom': $q.screen.gt.xs ? '20px' : undefined
    }"
    flat
    :bordered="$q.screen.gt.xs"
    @click="navigateToActivityPage()"
  >
    <component
      :is="!$isLandscapeView() || $q.screen.lt.sm || compact? 'q-card-section' : 'div'"
      :horizontal="!$isLandscapeView() || $q.screen.lt.sm || compact"
    >
      <q-img
        :class="{
          'poster': !$isLandscapeView() || $q.screen.lt.sm || compact,
          'col-2': !$isLandscapeView() && $q.screen.xs,
          'col-3': !$isLandscapeView() && $q.screen.gt.xs
        }"
        :src="compact || ($isLandscapeView() && $q.screen.lt.md) ? activity.bannerImageUrl : activity.posterImageUrl"
      />
      <q-card-section
        :class="{
          'q-pa-none': $isLandscapeView(),
          'q-pb-sm q-pt-none q-px-none': !$isLandscapeView(),
          'col-10': !$isLandscapeView() && $q.screen.xs,
          'col-9': !$isLandscapeView() && $q.screen.gt.xs,
          'full-width': compact
        }"
      >
        <div
          class="column"
          :class="$q.screen.gt.xs ? 'q-pa-md' : 'q-pa-sm'"
        >
          <div
            class="activity-name text-bold text-body1"
            :class="{ 'q-mb-sm': compact }"
            style="line-height : 1.5rem"
          >
            {{ activity.name }}
          </div>
          <div
            v-if="compact"
            class="row q-px-none"
          >
            <div
              v-if="activitySession"
              class="q-pa-none col-6"
            >
              <div
                class="text-caption"
              >
                {{ $d(new Date(activitySession.siteStartTime), 'longDate') }}
              </div>
              <div
                class="text-grey-7 text-caption"
              >
                {{ $d(new Date(activitySession.siteStartTime), 'shortTime') }}
              </div>
            </div>
            <div
              class="q-pa-none col-6"
            >
              <div
                class="text-caption"
              >
                {{ currentSite.displayName }}
              </div>
              <div
                v-if="activitySession"
                class="text-grey-7 text-caption"
              >
                {{ activitySession.activitySpace.name }}
              </div>
            </div>
          </div>
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <!-- Set internally by trusted admins -->
        <template v-if="!compact">
          <q-separator v-if="$isLandscapeView() && $q.screen.gt.xs && !compact" />
          <!-- eslint-enable vue/no-v-html -->
          <div
            v-if="activitySession"
            :class="$q.screen.gt.xs ? 'q-pa-md column' : 'row q-gutter-xs q-pl-sm'"
          >
            <div
              :class="$q.screen.gt.xs ? 'text-body1' : 'text-body2 col-auto text-dark'"
            >
              {{ $d(new Date(activitySession.siteStartTime), 'longDate') }}
            </div>
            <div
              class="text-grey-7"
              :class="$q.screen.gt.xs ? 'text-body1' : 'text-body2 col'"
            >
              {{ $d(new Date(activitySession.siteStartTime), 'shortTime') }}
            </div>
          </div>
          <q-separator v-if="$isLandscapeView() && $q.screen.gt.xs && !compact" />
          <div
            :class="$q.screen.gt.xs ? 'q-pa-md column' : 'row q-gutter-xs q-pl-sm'"
          >
            <div
              :class="$q.screen.gt.xs ? 'text-body1' : 'text-body2 col-auto'"
            >
              {{ currentSite.displayName }}
            </div>
            <div
              v-if="activitySession"
              class="text-grey-7"
              :class="$q.screen.gt.xs ? 'text-body1' : 'text-body2 col'"
            >
              {{ activitySession.activitySpace.name }}
            </div>
          </div>
        </template>
      </q-card-section>
    </component>
  </q-card>
</template>

<script>
import Activity from 'src/models/activity/Activity'
import ActivitySession from 'src/models/activity-session/ActivitySession'

export default {
  name: 'ActivityCard',
  props: {
    activity: {
      type: Activity,
      required: true
    },
    activitySession: {
      type: ActivitySession,
      default: null
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  configuration: ['currentSite'],
  methods: {
    navigateToActivityPage () {
      this.$q.dialog({
        title: 'Leave Checkout',
        message: 'Are you sure you want to leave checkout?',
        ok: {
          label: 'Go To Activity',
          color: 'primary'
        },
        cancel: {
          label: 'Stay',
          color: 'secondary'
        }
      }).onOk(() => {
        this.order.reset()
        this.$router.push(`/activity/${this.findActivityBySlug.urlSlug}`)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .poster {
    max-width: 200px;
    min-width: 150px;
  }
  .activity-card {
    width: 100%;
    margin-bottom: 20px;
  }
  .activity-name {
    color: var(--q-primary);
    font-size: 24px;
    font-weight: bold;
  }
</style>
